import React from 'react';

const Services = () => {
  const freshaBookingUrl =
    "https://www.fresha.com/a/zoteya-beauty-salon-sandton-33-wessel-road-bw27doko?pId=2602836";

  const services = [
    {
      title: "Sew in with Leave Out",
      description:
        "Includes wash, hydration treatment, cornrows, oiling of scalp, net, sewing in bundles, styling.",
      price: "R 1 200",
      duration: "3 hrs 30 mins",
      image: "/sew%20in.jpeg",
      alt: "Sew in with Leave Out",
    },
    {
      title: "Wig Making",
      description:
        "Custom wig construction with high-quality materials and professional styling.",
      price: "From R 800",
      duration: "2-4 hrs",
      image: "/wig%20making.jpeg",
      alt: "Wig Making",
    },
    {
      title: "2 x 6 Closure Sew in",
      description:
        "Natural-looking closure installation with precision sewing technique.",
      price: "From R 950",
      duration: "3 hrs",
      image:
        "https://www.stemahair.com/image/catalog/product/Closure/Lace%20Closure%202x6/BW/2021.jpg",
      alt: "Closure Sew in",
    },
    {
      title: "Hair Extensions Installation",
      description:
        "Premium hair extension installation for length and volume.",
      price: "From R 1 500",
      duration: "2-5 hrs",
      image:
        "https://myextensions.co.za/wp-content/uploads/2024/02/installation.jpg",
      alt: "Hair Extensions",
    },
    {
      title: "Facial & Skin Care",
      description: "Professional facial treatments for glowing, healthy skin.",
      price: "From R 350",
      duration: "1 hr",
      image:
        "https://thumbs.dreamstime.com/b/young-african-woman-beauty-salon-spa-getting-facial-treatment-beauty-salon-spa-161550864.jpg",
      alt: "Facial and Skin Care",
    },
    {
      title: "Hair Treatments",
      description: "Deep conditioning and repair treatments for all hair types.",
      price: "From R 250",
      duration: "45 mins",
      image: "/treatment.jpeg",
      alt: "Hair Treatments",
    },
  ];

  return (
    <section id="services" className="py-5" style={{ background: "#ffffff" }}>
      <div className="container">
        <h2
          className="text-center fw-bold mb-2"
          style={{
            color: "#2c2c2c",
            fontFamily: "'Playfair Display',serif",
            letterSpacing: ".025em",
            fontSize: "1.28rem",
          }}
        >
          Our Services
        </h2>
        <p
          className="text-center text-muted mb-3"
          style={{
            fontWeight: 400,
            fontSize: ".97rem",
            maxWidth: 450,
            margin: "0 auto",
          }}
        >
          Experience luxury hair care and beauty treatments tailored to your style.
        </p>

        {/* 3 columns on mobile via col-4 */}
        <div
          className="row justify-content-center"
          style={{ rowGap: "0.7rem", columnGap: "0.2rem" }}
        >
          {services.map(({ image, alt, title, description, price, duration }, idx) => (
            <div
              key={idx}
              className="col-4 col-md-3 col-lg-3 d-flex flex-column align-items-stretch"
              style={{
                paddingLeft: 0,
                paddingRight: 0,
              }}
            >
              <div
                className="w-100"
                style={{
                  background: "#fff",
                  borderRadius: 8,
                  boxShadow: "0 2px 7px #cab38a19",
                  padding: "0.57rem 0.5rem 0.4rem 0.5rem",
                  transition: "transform .16s, box-shadow .17s",
                  height: "100%",
                }}
              >
                {/* Image frame so pictures are not cut off */}
                <div
                  style={{
                    width: "100%",
                    height: 120,
                    borderRadius: 6,
                    overflow: "hidden",
                    background: "#f5eee0",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    marginBottom: 7,
                  }}
                >
                  <img
                    src={image}
                    alt={alt}
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "contain",
                      display: "block",
                    }}
                    onError={(e) => {
                      if (!e.target.dataset.fallback) {
                        e.target.dataset.fallback = "true";
                        e.target.src = "/placeholder-image.jpg";
                      }
                    }}
                  />
                </div>

                <div
                  style={{
                    fontSize: ".98em",
                    color: "#453e38",
                    fontWeight: 700,
                    fontFamily: "'Playfair Display',serif",
                    marginBottom: 4,
                    minHeight: "32px",
                    textAlign: "center",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                  }}
                >
                  {title}
                </div>
                <div
                  style={{
                    fontSize: ".91em",
                    color: "#6d6046",
                    textAlign: "center",
                    marginBottom: 3,
                    minHeight: "28px",
                    overflow: "hidden",
                  }}
                >
                  {description}
                </div>
                <div
                  style={{
                    color: "#2c2c2c",
                    fontWeight: 700,
                    fontSize: ".97em",
                    textAlign: "center",
                  }}
                >
                  {price}{" "}
                  <span
                    style={{
                      color: "#9d8b66",
                      fontWeight: 500,
                      fontSize: ".94em",
                      marginLeft: 7,
                    }}
                  >
                    {duration}
                  </span>
                </div>
                <a
                  href={freshaBookingUrl}
                  className="btn rounded-pill w-100 fw-bold mt-2"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    background: "linear-gradient(90deg,#c4a15a,#d4c4a8)",
                    color: "#fff",
                    fontSize: ".965em",
                    letterSpacing: ".01em",
                    border: "none",
                    fontFamily: "'Playfair Display',serif",
                  }}
                  onMouseOver={(e) =>
                    (e.currentTarget.style.background = "#cab27c")
                  }
                  onMouseOut={(e) =>
                    (e.currentTarget.style.background =
                      "linear-gradient(90deg,#c4a15a,#d4c4a8)")
                  }
                >
                  Book Now
                </a>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-4">
          <a
            href={freshaBookingUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="btn rounded-pill fw-bold"
            style={{
              background: "#d4c4a8",
              color: "#3a3a3a",
              fontSize: ".97rem",
              border: "none",
            }}
          >
            Explore More Services on Fresha
          </a>
        </div>
      </div>
    </section>
  );
};

export default Services;
